import { StyleSheet, Text } from '@react-pdf/renderer'
import React from 'react'
import { ErrorBoundary } from '../../error-boundary'

const styles = StyleSheet.create({
	paragraph: {
		fontFamily: 'Inter',
		fontSize: 8,
		marginBottom: 6,
		textAlign: 'justify',
		lineHeight: 1.5,
	},
})

interface ParagraphProps {
	children: React.ReactNode
	strong?: boolean
}

const Paragraph = ({ children, strong }: ParagraphProps) => (
	<ErrorBoundary message={'Error in Paragraph'}>
		<Text style={[styles.paragraph, { fontWeight: strong ? 'bold' : 'normal' }]}>
			{children}
		</Text>
	</ErrorBoundary>
)

export default Paragraph
